import { AnimatePresence, motion } from "framer-motion";
import {
  ArrowLeft,
  ArrowRight,
  Calendar,
  Check,
  Mail,
  Phone,
  Search,
  Sparkles,
  Star,
  TrendingUp,
} from "lucide-react";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Button } from "../components/ui/button";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "../components/ui/carousel";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../components/ui/dialog";
import { ScrollArea } from "../components/ui/scroll-area";

import EmailGate from "../components/EmailGate";
import {
  buildContentTrackingMetadata,
  getStoredContentSessionId,
} from "../lib/gatedContentTracking";
import AgentTitleSlide from "../components/slides-ai-os/AgentTitleSlide";
import AIReceptionistSlide from "../components/slides-ai-os/AIReceptionistSlide";
import AlainaSlide from "../components/slides-ai-os/AlainaSlide";
import DenialManagementSlide from "../components/slides-ai-os/DenialManagementSlide";
import ArielSlide from "../components/slides-ai-os/ArielSlide";
import AshaVsDentinaReceptionistSlide from "../components/slides-ai-os/AshaVsDentinaReceptionistSlide";
import AshaVsDentinaSlide from "../components/slides-ai-os/AshaVsDentinaSlide";
import AshaVsWeaveSlide from "../components/slides-ai-os/AshaVsWeaveSlide";
import BackingSlide from "../components/slides-ai-os/BackingSlide";
import AshaVsEassistSlide from "../components/slides-ai-os/AshaVsEassistSlide";
import PMSPricingComparisonSlide from "../components/slides-ai-os/PMSPricingComparisonSlide";
import AshaOperatingSystemSlide from "../components/slides-ai-os/AshaOperatingSystemSlide";
import AshaBasicallyFreeSlide from "../components/slides-ai-os/AshaBasicallyFreeSlide";
import PriceMatchGuaranteeSlide from "../components/slides-ai-os/PriceMatchGuaranteeSlide";
import TotalPricingComparisonSlide from "../components/slides-ai-os/TotalPricingComparisonSlide";
import BenefitFormsSlide from "../components/slides-ai-os/BenefitFormsSlide";
import CommunicationSuiteSlide from "../components/slides-ai-os/CommunicationSuiteSlide";
import MarketingTitleSlide from "../components/slides-ai-os/MarketingTitleSlide";
import SMSCampaignsSlide from "../components/slides-ai-os/SMSCampaignsSlide";
import EmailCampaignsSlide from "../components/slides-ai-os/EmailCampaignsSlide";
import CommunicationTitleSlide from "../components/slides-ai-os/CommunicationTitleSlide";
import ComparisonsTitleSlide from "../components/slides-ai-os/ComparisonsTitleSlide";
import AshaVsLassieSlide from "../components/slides-ai-os/AshaVsLassieSlide";
import CompetitorAnalysisSlide from "../components/slides-ai-os/CompetitorAnalysisSlide";
import CommunicationSuiteComparisonSlide from "../components/slides-ai-os/CommunicationSuiteComparisonSlide";
import ComprehensiveBreakdownsSlide from "../components/slides-ai-os/ComprehensiveBreakdownsSlide";
import EFAXSlide from "../components/slides-ai-os/EFAXSlide";
import ElisePatientExperienceSlide from "../components/slides-ai-os/ElisePatientExperienceSlide";
import MorganPatientIntakeSlide from "../components/slides-ai-os/MorganPatientIntakeSlide";
import PracticeManagerSlide from "../components/slides-ai-os/PracticeManagerSlide";
import FrontOfficeGettingStartedSlide from "../components/slides-ai-os/FrontOfficeGettingStartedSlide";
import OnboardingTimelineSlide from "../components/slides-ai-os/OnboardingTimelineSlide";
import GettingStartedSlide from "../components/slides-ai-os/GettingStartedSlide";
import WhiteGloveOnboardingSlide from "../components/slides-ai-os/WhiteGloveOnboardingSlide";
import GoLiveTimelineSlide from "../components/slides-ai-os/GoLiveTimelineSlide";
import GoLiveTimelineIntegrationSlide from "../components/slides-ai-os/GoLiveTimelineIntegrationSlide";
import DataMigrationSlide from "../components/slides-ai-os/DataMigrationSlide";
import FAQSlide from "../components/slides-ai-os/FAQSlide";
import ConsolidationSlide from "../components/slides-ai-os/ConsolidationSlide";
import ProblemResonanceSlide from "../components/slides-ai-os/ProblemResonanceSlide";
import PerceivedOpportunitySlide from "../components/slides-ai-os/PerceivedOpportunitySlide";
import RealOpportunitySlide from "../components/slides-ai-os/RealOpportunitySlide";
import AtomicAutomationSlide from "../components/slides-ai-os/AtomicAutomationSlide";
import WhoWeTakeOnSlide from "../components/slides-ai-os/WhoWeTakeOnSlide";
import AutomationInflectionPointSlide from "../components/slides-ai-os/AutomationInflectionPointSlide";
import ManualTasksSlide from "../components/slides-ai-os/ManualTasksSlide";
import HygieneRecallSlide from "../components/slides-ai-os/HygieneRecallSlide";
import InsuranceCallingSlide from "../components/slides-ai-os/InsuranceCallingSlide";
import InsuranceCopilotSlide from "../components/slides-ai-os/InsuranceCopilotSlide";
import InsuranceVerificationSlide from "../components/slides-ai-os/InsuranceVerificationSlide";
import IntelligentSchedulingSlide from "../components/slides-ai-os/IntelligentSchedulingSlide";
import KimCaseAcceptanceSlide from "../components/slides-ai-os/KimCaseAcceptanceSlide";
import LenaSlide from "../components/slides-ai-os/LenaSlide";
import LenaWorkflowSlide from "../components/slides-ai-os/LenaWorkflowSlide";
import NextGenFormsSlide from "../components/slides-ai-os/NextGenFormsSlide";
import VoIPSlide from "../components/slides-ai-os/VoIPSlide";
import PhysicalPhonesSlide from "../components/slides-ai-os/PhysicalPhonesSlide";
import TextToPaySlide from "../components/slides-ai-os/TextToPaySlide";
import CardReadersSlide from "../components/slides-ai-os/CardReadersSlide";
import TeamChatSlide from "../components/slides-ai-os/TeamChatSlide";
import OnlineSchedulingSlide from "../components/slides-ai-os/OnlineSchedulingSlide";
import PMSSchedulingSlide from "../components/slides-ai-os/PMSSchedulingSlide";
import PMSChartingSlideAnimated from "../components/slides-ai-os/PMSChartingSlideAnimated";
import PMSTreatmentPlanningSlide from "../components/slides-ai-os/PMSTreatmentPlanningSlide";
import PMSClinicalNotesSlide from "../components/slides-ai-os/PMSClinicalNotesSlide";
import PMSFileManagementSlide from "../components/slides-ai-os/PMSFileManagementSlide";
import PMSImagingSlide from "../components/slides-ai-os/PMSImagingSlide";
import PMSAITreatmentPlannerSlide from "../components/slides-ai-os/PMSAITreatmentPlannerSlide";
import PMSRevenueAnalyticsSlide from "../components/slides-ai-os/PMSRevenueAnalyticsSlide";
import PMSAIScribeSlide from "../components/slides-ai-os/PMSAIScribeSlide";
import PMSAshaCopilotSlide from "../components/slides-ai-os/PMSAshaCopilotSlide";
import VoicePerioSlide from "../components/slides-ai-os/VoicePerioSlide";
import AIDictationSlide from "../components/slides-ai-os/AIDictationSlide";
import WhatYouGetSlide from "../components/slides-ai-os/WhatYouGetSlide";

import EOBProcessingSlide from "../components/slides-ai-os/EOBProcessingSlide";
import EOBStreamliningSlide from "../components/slides-ai-os/EOBStreamliningSlide";
import PatientBillingSlide from "../components/slides-ai-os/PatientBillingSlide";
import PaymentReconciliationSlide from "../components/slides-ai-os/PaymentReconciliationSlide";

import PMSDemoSlide from "../components/slides-ai-os/PMSDemoSlide";
import PMSTeamIntro1Slide from "../components/slides-ai-os/PMSTeamIntro1Slide";
import PMSTeamIntro2Slide from "../components/slides-ai-os/PMSTeamIntro2Slide";
import AIWorkforceSlide from "../components/slides-ai-os/AIWorkforceSlide";
import PlatformAndAIWorkforceSlide from "../components/slides-ai-os/PlatformAndAIWorkforceSlide";
import AIROISlide from "../components/slides-ai-os/AIROISlide";
import AIClinicSlide from "../components/slides-ai-os/AIClinicSlide";
import AshaCortexSlide from "../components/slides-ai-os/AshaCortexSlide";
import AriaAutopilotSlide from "../components/slides-ai-os/AriaAutopilotSlide";
import OverviewTestimonialsSlide from "../components/slides-ai-os/OverviewTestimonialsSlide";
import agentDemoScenarios from "../components/agentDemoScenariosAiOs";

// NEW OS-specific slides
import AIFunctionsSlide from "../components/slides-ai-os/AIFunctionsSlide";
import AIFunctionsValueSlide from "../components/slides-ai-os/AIFunctionsValueSlide";
import SoftwareStackCostSlide from "../components/slides-ai-os/SoftwareStackCostSlide";
import RCMPricingComparisonSlide from "../components/slides-ai-os/RCMPricingComparisonSlide";
import FrontOfficePricingComparisonSlide from "../components/slides-ai-os/FrontOfficePricingComparisonSlide";
import EngagementOptionsSlide from "../components/slides-ai-os/EngagementOptionsSlide";
import PMSEfficiencyCaseSlide from "../components/slides-ai-os/PMSEfficiencyCaseSlide";
import IntegrationPartnersSlide from "../components/slides-ai-os/IntegrationPartnersSlide";
import MigrationPartnersSlide from "../components/slides-ai-os/MigrationPartnersSlide";
import FlexiblePlanSlide from "../components/slides-ai-os/FlexiblePlanSlide";
import AIOSEmphasisSlide from "../components/slides-ai-os/AIOSEmphasisSlide";
import PartnershipSlide from "../components/slides-ai-os/PartnershipSlide";
import DeRiskProcessSlide from "../components/slides-ai-os/DeRiskProcessSlide";
import EngagementTitleSlide from "../components/slides-ai-os/EngagementTitleSlide";
import HowCanWeHelpSlide from "../components/slides-ai-os/HowCanWeHelpSlide";
import ROICalculatorSlide from "../components/slides-ai-os/ROICalculatorSlide";
import FellowsIntroSlide from "../components/slides-ai-os/FellowsIntroSlide";
import FellowsThoughtLeadershipSlide from "../components/slides-ai-os/FellowsThoughtLeadershipSlide";
import FellowsAgentBuilderSlide from "../components/slides-ai-os/FellowsAgentBuilderSlide";
import FellowsPartnerPerksSlide from "../components/slides-ai-os/FellowsPartnerPerksSlide";
import AICreditFAQSlide from "../components/slides-ai-os/AICreditFAQSlide";
import PiecemealTotalSlide from "../components/slides-ai-os/PiecemealTotalSlide";

const osSlides = [
  { id: 0, slug: "welcome", title: "Welcome", indent: 0 },
  // Overview
  { id: 300, slug: "overview", title: "Overview", indent: 0 },
  { id: 1, slug: "why-asha", title: "Why Asha?", indent: 1 },
  { id: 2, slug: "backing", title: "Backing & Team", indent: 1 },
  { id: 319, slug: "de-risk-process", title: "How We De-Risk the Decision", indent: 1 },
  { id: 311, slug: "problem-resonance", title: "What Are You Here to Solve?", indent: 1 },
  { id: 305, slug: "ai-clinic", title: "10+ Softwares + 20+ AI Products in 1 Platform", indent: 1 },
  { id: 320, slug: "who-we-take-on", title: "Which Practices We Take On", indent: 1 },
  { id: 318, slug: "partnership", title: "How We Partner With You", indent: 1 },
  { id: 317, slug: "atomic-automation-overview", title: "Automation Inflection Point", indent: 1 },
  { id: 306, slug: "aria", title: "ARIA", indent: 1 },
  { id: 308, slug: "overview-testimonials", title: "What Dentists Have to Say About ASHA", indent: 1 },
  // The ASHA Transformation
  { id: 350, slug: "asha-transformation", title: "The ASHA Transformation", indent: 0 },
  { id: 312, slug: "perceived-opportunity", title: "The 10–15% Assumption", indent: 1 },
  { id: 313, slug: "real-opportunity", title: "The Real Opportunity", indent: 1 },
  { id: 315, slug: "atomic-automation", title: "The Atomic Automation Threshold", indent: 1 },
  { id: 157, slug: "consolidation", title: "10+ Softwares", indent: 1 },
  { id: 158, slug: "manual-tasks", title: "40+ Tasks", indent: 1 },
  { id: 310, slug: "how-can-we-help", title: "So How Can We Help?", indent: 1 },
  { id: 304, slug: "ai-workforce", title: "Platform & AI Workforce", indent: 1 },
  // Front Office AI Team
  { id: 3, slug: "ai-team-1", title: "Front Office AI Team", indent: 0 },
  { id: 4, slug: "amy", title: "Amy, Receptionist", indent: 1 },
  { id: 5, slug: "amy-features", title: "Features", indent: 2 },
  { id: 6, slug: "amy-scheduling", title: "Intelligent Scheduling", indent: 2 },
  { id: 7, slug: "leena", title: "Leena, Schedule Optimizer", indent: 1 },
  { id: 8, slug: "leena-features", title: "Features", indent: 2 },
  { id: 9, slug: "leena-workflow", title: "12-Step Workflow", indent: 2 },
  { id: 10, slug: "stephanie", title: "Stephanie, Hygiene Recall", indent: 1 },
  { id: 11, slug: "stephanie-features", title: "Features", indent: 2 },
  { id: 110, slug: "kim", title: "Kim, Case Acceptance", indent: 1 },
  { id: 111, slug: "kim-revenue", title: "Revenue Automation", indent: 2 },
  { id: 112, slug: "elise", title: "Elise, Patient Experience", indent: 1 },
  { id: 113, slug: "elise-reviews", title: "Review Generation", indent: 2 },
  { id: 114, slug: "morgan", title: "Morgan, Patient Intake", indent: 1 },
  { id: 115, slug: "morgan-intake", title: "Intake & Insurance", indent: 2 },
  { id: 116, slug: "practice-manager", title: "Trisha, Practice Manager", indent: 1 },
  { id: 117, slug: "practice-manager-dashboard", title: "Task Dashboard", indent: 2 },
  // Communication Suite
  { id: 17, slug: "comms-suite", title: "Communication Suite", indent: 0 },
  { id: 18, slug: "voip", title: "VoIP", indent: 1 },
  { id: 29, slug: "forms", title: "Next-Gen Forms", indent: 1 },
  { id: 19, slug: "messaging", title: "2-Way Messaging", indent: 1 },
  { id: 20, slug: "fax", title: "Intelligent Fax", indent: 1 },
  { id: 201, slug: "sms-campaigns", title: "SMS Campaigns", indent: 1 },
  { id: 202, slug: "email-campaigns", title: "Email Campaigns", indent: 1 },
  { id: 2041, slug: "physical-phones", title: "Physical Phones", indent: 1 },
  { id: 2051, slug: "text-to-pay", title: "Text-to-Pay", indent: 1 },
  { id: 206, slug: "card-readers", title: "Card Readers", indent: 1 },
  { id: 207, slug: "team-chat", title: "Team Chat", indent: 1 },
  { id: 208, slug: "online-scheduling", title: "Online Scheduling", indent: 1 },
  // Revenue Cycle AI Team
  { id: 22, slug: "ai-team-2", title: "Revenue Cycle AI Team", indent: 0 },
  { id: 12, slug: "amanda", title: "Amanda, Insurance Verification", indent: 1 },
  { id: 13, slug: "amanda-checks", title: "Automatic Checks", indent: 2 },
  { id: 30, slug: "amanda-breakdowns", title: "Comprehensive Breakdowns", indent: 2 },
  { id: 31, slug: "amanda-copilot", title: "AI Insurance Co-Pilot", indent: 2 },
  { id: 16, slug: "amanda-forms", title: "Automated Forms", indent: 2 },
  { id: 15, slug: "amanda-calling", title: "AI Calling", indent: 2 },
  { id: 23, slug: "ariel", title: "Ariel, Claims Expert", indent: 1 },
  { id: 24, slug: "ariel-submission", title: "Claim Submission", indent: 2 },
  { id: 101, slug: "ariel-scrubbing", title: "Claim Scrubbing", indent: 2 },
  { id: 100, slug: "alisha", title: "Alisha, EOB Posting", indent: 1 },
  { id: 25, slug: "alisha-posting", title: "Automated Posting", indent: 2 },
  { id: 102, slug: "alisha-reconciliation", title: "Payment Reconciliation", indent: 2 },
  { id: 103, slug: "alisha-ingestion", title: "Unified Ingestion", indent: 2 },
  { id: 26, slug: "kianna", title: "Kianna, Patient Billing", indent: 1 },
  { id: 104, slug: "kianna-campaigns", title: "Voice Campaigns", indent: 2 },
  { id: 700, slug: "sarah", title: "Sarah, Denial Management", indent: 1 },
  { id: 701, slug: "sarah-denial-analysis", title: "AI Denial Analysis", indent: 2 },
  // Revenue Analytics
  { id: 420, slug: "revenue-analytics-suite", title: "Revenue Analytics Suite", indent: 0 },
  { id: 408, slug: "pms-revenue-analytics", title: "AI Revenue Analytics", indent: 1 },
  // PMS Features
  { id: 400, slug: "pms-features", title: "PMS Features", indent: 0 },
  { id: 410, slug: "pms-asha-copilot", title: "Asha AI Co-Pilot", indent: 1 },
  { id: 401, slug: "pms-scheduling", title: "Smart Scheduling", indent: 1 },
  { id: 402, slug: "pms-charting", title: "Clinical Charting", indent: 1 },
  { id: 411, slug: "pms-voice-perio", title: "Voice Perio", indent: 1 },
  { id: 412, slug: "pms-ai-dictation", title: "AI Dictation", indent: 1 },
  { id: 404, slug: "pms-clinical-notes", title: "Clinical Notes", indent: 1 },
  { id: 405, slug: "pms-file-management", title: "Document Management", indent: 1 },
  { id: 406, slug: "pms-imaging", title: "Digital Imaging", indent: 1 },
  { id: 407, slug: "pms-ai-treatment-planner", title: "AI Treatment Planner", indent: 1 },
  { id: 409, slug: "pms-ai-scribe", title: "AI Scribe", indent: 1 },
  // Engagement & Pricing — single consolidated section covering both models
  { id: 620, slug: "engagement-options", title: "Two Engagement Models", indent: 0 },
  { id: 631, slug: "what-you-get", title: "What You Get", indent: 1 },
  { id: 625, slug: "migration-partners", title: "PMS Integrations & Migrations", indent: 1 },
  { id: 156, slug: "data-migration", title: "Seamless Data Migration", indent: 1 },
  { id: 109, slug: "white-glove-onboarding", title: "Onboarding & Strategy Advisory", indent: 1 },
  { id: 211, slug: "go-live-timeline", title: "4-Week Go-Live", indent: 1 },
  // ROI
  { id: 660, slug: "roi-impact", title: "ROI Impact", indent: 0 },
  { id: 608, slug: "roi-calculator", title: "ROI Calculator", indent: 1 },
  { id: 2042, slug: "asha-basically-free", title: "Asha Pays for Itself", indent: 1 },
  // AI Innovation Fellows
  { id: 900, slug: "fellows", title: "AI Innovation Fellows", indent: 0 },
  { id: 901, slug: "fellows-intro", title: "The Program", indent: 1 },
  { id: 904, slug: "fellows-partner-perks", title: "Partner Perks", indent: 1 },
  // FAQ
  { id: 215, slug: "faq", title: "FAQ", indent: 0 },
  { id: 216, slug: "frequently-asked-questions", title: "Frequently Asked Questions", indent: 1 },
  { id: 217, slug: "ai-credits", title: "AI Credit Utilization", indent: 1 },
];

// Window-mount a slide: render its real content only when within `radius` of
// the active index; otherwise render a cheap placeholder so we don't keep
// 100+ animated slides mounted at once.
const LazySlide = ({ index, activeIndex, radius = 2, children }) => {
  const visible = Math.abs(index - activeIndex) <= radius;
  return visible ? children : <div className="h-full w-full bg-slate-50" />;
};

// Wraps CarouselContent; clones each CarouselItem child so its inner content
// is window-mounted based on distance from the active index.
const LazyCarouselContent = ({ activeIndex, radius = 2, children, ...props }) => {
  let idx = 0;
  const mapped = React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) return child;
    const itemIndex = idx++;
    return React.cloneElement(child, {
      children: (
        <LazySlide index={itemIndex} activeIndex={activeIndex} radius={radius}>
          {child.props.children}
        </LazySlide>
      ),
    });
  });
  return <CarouselContent {...props}>{mapped}</CarouselContent>;
};

const ACCESS_STORAGE_KEY = "asha_ai_os_slideshow_access";
const SESSION_STORAGE_KEY = "asha_ai_os_slideshow_session_id";

const AIOSSlideshowPage = ({ excludePractices = [] }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [api, setApi] = useState(null);
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [scale, setScale] = useState(1);
  const [isLocked, setIsLocked] = useState(true);
  const containerRef = React.useRef(null);
  const slideStartTimeRef = React.useRef(Date.now());
  const currentSlideRef = React.useRef(0);

  const recordSlideView = (slideIndex, duration, useBeacon = false) => {
    const sessionId = getStoredContentSessionId(SESSION_STORAGE_KEY);
    if (!sessionId || duration < 1000) return;

    const slide = osSlides[slideIndex];
    const payload = JSON.stringify({
      sessionId,
      slideId: slide?.id ?? slideIndex,
      slideTitle: slide?.title ?? `Slide ${slideIndex}`,
      slideSlug: slide?.slug,
      durationSeconds: Math.round(duration / 1000),
      ...buildContentTrackingMetadata({ contentType: "slideshow" }),
    });

    const isLocalhost =
      typeof window !== "undefined" &&
      (window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1");
    const apiUrl =
      process.env.REACT_APP_API_URL ||
      (isLocalhost ? "http://localhost:8001" : "");
    const url = `${apiUrl}/api/slideshow/slide-view`;

    if (useBeacon && typeof navigator !== "undefined" && navigator.sendBeacon) {
      const blob = new Blob([payload], { type: "application/json" });
      navigator.sendBeacon(url, blob);
      return;
    }

    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: payload,
      keepalive: true,
    }).catch((err) => console.error("Failed to record slide view", err));
  };

  useEffect(() => {
    const hasAccess = localStorage.getItem(ACCESS_STORAGE_KEY);
    const sessionId = getStoredContentSessionId(SESSION_STORAGE_KEY);
    if (hasAccess && sessionId) {
      setIsLocked(false);
    }
  }, []);

  const handleAccessGranted = (email) => {
    localStorage.setItem(ACCESS_STORAGE_KEY, "true");
    console.log("Access granted for:", email);
    currentSlideRef.current = api?.selectedScrollSnap?.() ?? 0;
    slideStartTimeRef.current = Date.now();
    setIsLocked(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        const parentWidth = containerRef.current.offsetWidth;
        const targetWidth = 1400;
        const newScale = parentWidth / targetWidth;
        setScale(newScale);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!api) {
      return;
    }

    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);

    api.on("select", () => {
      const newIndex = api.selectedScrollSnap();

      const now = Date.now();
      const duration = now - slideStartTimeRef.current;

      recordSlideView(currentSlideRef.current, duration);

      currentSlideRef.current = newIndex;
      slideStartTimeRef.current = now;

      setCurrent(newIndex + 1);

      const slideSlug = osSlides[newIndex]?.slug;
      if (slideSlug) {
        setSearchParams({ slide: slideSlug }, { replace: true });
      }
    });

    return () => {
      const now = Date.now();
      const duration = now - slideStartTimeRef.current;
      recordSlideView(currentSlideRef.current, duration);
    };
  }, [api, setSearchParams]);

  useEffect(() => {
    const flushOnHide = () => {
      const now = Date.now();
      const duration = now - slideStartTimeRef.current;
      recordSlideView(currentSlideRef.current, duration, true);
      slideStartTimeRef.current = now;
    };
    window.addEventListener("pagehide", flushOnHide);
    return () => window.removeEventListener("pagehide", flushOnHide);
  }, []);

  useEffect(() => {
    if (!api) return;

    const handleKeyDown = (event) => {
      if (event.key === "ArrowRight") {
        api.scrollNext();
      } else if (event.key === "ArrowLeft") {
        api.scrollPrev();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [api]);

  useEffect(() => {
    if (!api) return;

    const slideParam = searchParams.get("slide");
    if (slideParam) {
      // Legacy slug aliases — keep old URLs working after slide consolidations
      const slugAliases = {
        "engagement-model-1": "engagement-options",
        "engagement-model-2": "engagement-options",
        "asha-pms-whats-included": "what-you-get",
        "integration-partners": "migration-partners",
        "integration-go-live": "go-live-timeline",
      };
      const resolvedSlug = slugAliases[slideParam] || slideParam;
      let slideIndex = osSlides.findIndex((s) => s.slug === resolvedSlug);

      if (slideIndex === -1) {
        const slideId = parseInt(slideParam, 10);
        if (!isNaN(slideId)) {
          slideIndex = osSlides.findIndex((s) => s.id === slideId);
        }
      }

      if (slideIndex !== -1) {
        setTimeout(() => {
          api.scrollTo(slideIndex);
        }, 100);
      }
    }
  }, [api, searchParams]);

  const filteredSlides = osSlides
    .map((slide, index) => ({ ...slide, originalIndex: index }))
    .filter((slide) =>
      slide.title.toLowerCase().includes(searchQuery.toLowerCase())
    );

  return (
    <div className="min-h-screen xl:h-screen w-screen bg-neutral-900 flex flex-col items-center justify-start p-2 md:p-8 pt-4 xl:pt-4 overflow-y-auto xl:overflow-hidden overflow-x-hidden relative">
      <AnimatePresence>
        {isLocked && <EmailGate onAccessGranted={handleAccessGranted} sessionStorageKey={SESSION_STORAGE_KEY} />}
      </AnimatePresence>

      {/* Top Actions */}
      <div className="w-full max-w-[1800px] flex justify-between items-center gap-3 mb-4 z-50">
        <div className="relative group px-1 w-[260px]">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-white/30 group-focus-within:text-blue-400 transition-colors" />
          <input
            type="text"
            placeholder="Search slides..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full bg-white/5 border border-white/10 rounded-xl py-2.5 pl-10 pr-4 text-sm text-white placeholder:text-white/20 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500/50 transition-all shadow-inner"
          />
        </div>

        <div className="flex items-center gap-3">
          <Dialog>
            <DialogTrigger asChild>
              <Button
                variant="outline"
                className="bg-white/5 backdrop-blur-sm border-white/10 text-white hover:bg-white/10 hover:text-white"
              >
                I have questions
              </Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-md bg-white border-0 shadow-2xl rounded-2xl p-0 overflow-hidden">
              <DialogHeader className="p-6 pb-2">
                <DialogTitle className="text-2xl font-bold text-slate-900 tracking-tight">
                  Get in Touch
                </DialogTitle>
                <DialogDescription className="text-slate-500 text-base">
                  Have questions about Asha? We're here to help.
                </DialogDescription>
              </DialogHeader>
              <div className="flex flex-col gap-3 p-6 pt-2">
                <Button
                  variant="outline"
                  className="w-full justify-start gap-4 h-auto py-4 px-4 text-left border-slate-200 hover:border-blue-300 hover:bg-blue-50/30 hover:shadow-md transition-all duration-200 group bg-white rounded-xl shadow-sm"
                  onClick={() =>
                    window.open(
                      "https://calendly.com/asha-health/dental-one-stop-shop",
                      "_blank"
                    )
                  }
                >
                  <div className="w-12 h-12 rounded-2xl bg-blue-100 flex items-center justify-center text-blue-600 shrink-0 group-hover:scale-105 transition-transform duration-200 shadow-sm border border-blue-200">
                    <Calendar className="w-6 h-6" />
                  </div>
                  <div className="flex flex-col items-start gap-1">
                    <span className="font-semibold text-slate-900 text-base group-hover:text-blue-700 transition-colors">
                      Book a meeting
                    </span>
                    <span className="text-sm text-slate-500">
                      Schedule time with our team
                    </span>
                  </div>
                </Button>

                <Button
                  variant="outline"
                  className="w-full justify-start gap-4 h-auto py-4 px-4 text-left border-slate-200 hover:border-green-300 hover:bg-green-50/30 hover:shadow-md transition-all duration-200 group bg-white rounded-xl shadow-sm"
                  onClick={() => (window.location.href = "sms:+19146779846")}
                >
                  <div className="w-12 h-12 rounded-2xl bg-green-100 flex items-center justify-center text-green-600 shrink-0 group-hover:scale-105 transition-transform duration-200 shadow-sm border border-green-200">
                    <Phone className="w-6 h-6" />
                  </div>
                  <div className="flex flex-col items-start gap-1">
                    <span className="font-semibold text-slate-900 text-base group-hover:text-green-700 transition-colors">
                      Text us
                    </span>
                    <span className="text-sm font-bold text-slate-700">
                      (914) 677-9846
                    </span>
                  </div>
                </Button>

                <Button
                  variant="outline"
                  className="w-full justify-start gap-4 h-auto py-4 px-4 text-left border-slate-200 hover:border-purple-300 hover:bg-purple-50/30 hover:shadow-md transition-all duration-200 group bg-white rounded-xl shadow-sm"
                  onClick={() =>
                    (window.location.href = "mailto:onboarding@asha.health")
                  }
                >
                  <div className="w-12 h-12 rounded-2xl bg-purple-100 flex items-center justify-center text-purple-600 shrink-0 group-hover:scale-105 transition-transform duration-200 shadow-sm border border-purple-200">
                    <Mail className="w-6 h-6" />
                  </div>
                  <div className="flex flex-col items-start gap-1">
                    <span className="font-semibold text-slate-900 text-base group-hover:text-purple-700 transition-colors">
                      Email us
                    </span>
                    <span className="text-sm font-bold text-slate-700">
                      onboarding@asha.health
                    </span>
                  </div>
                </Button>
              </div>
            </DialogContent>
          </Dialog>
        </div>
      </div>

      <div className="w-full max-w-[1800px] flex flex-col xl:flex-row gap-6 items-center justify-center flex-1 min-h-0">
        {/* Table of Contents */}
        <div className="w-full xl:w-[260px] flex flex-col flex-1 xl:flex-none xl:h-full py-4 xl:pt-0 xl:pb-8 pr-0 xl:pr-2 order-2 xl:order-1 min-h-[300px]">
          <ScrollArea className="flex-1 -mr-2 pr-4 custom-scrollbar">
            <div className="pl-4 border-l border-white/10 space-y-2 py-2">
              {filteredSlides.map((slide) => (
                <button
                  key={`${slide.id}-${slide.slug}`}
                  onClick={() => api?.scrollTo(slide.originalIndex)}
                  className={`group flex items-center gap-3 w-full text-left transition-all duration-300 relative py-1.5 ${
                    current === slide.originalIndex + 1
                      ? "opacity-100"
                      : "opacity-40 hover:opacity-80"
                  }`}
                  style={{ paddingLeft: `${(slide.indent || 0) * 16}px` }}
                >
                  <div
                    className={`absolute -left-[17px] h-full w-[3px] rounded-full transition-all duration-500 ${
                      current === slide.originalIndex + 1
                        ? "bg-blue-500 opacity-100 shadow-[0_0_10px_rgba(59,130,246,0.5)]"
                        : "bg-transparent opacity-0"
                    }`}
                  />

                  <span
                    className={`text-sm font-medium tracking-wide transition-all duration-300 truncate ${
                      current === slide.originalIndex + 1
                        ? "text-blue-400 translate-x-1"
                        : "text-white"
                    }`}
                  >
                    {slide.title}
                  </span>
                </button>
              ))}
              {filteredSlides.length === 0 && (
                <div className="text-white/30 text-sm italic py-4">
                  No slides found
                </div>
              )}
            </div>
          </ScrollArea>
        </div>

        {/* Main Slide Container */}
        <div className="w-full xl:flex-1 max-w-[1400px] aspect-video relative order-1 xl:order-2 flex-shrink-0 group">
          <div
            ref={containerRef}
            className="w-full h-full overflow-hidden bg-transparent relative"
          >
            <div
              style={{
                width: "1400px",
                height: "787.5px",
                transform: `scale(${scale})`,
                transformOrigin: "top left",
                position: "absolute",
                top: 0,
                left: 0,
              }}
            >
              <Carousel setApi={setApi} className="w-full h-full">
                <div className="w-full h-full bg-white rounded-3xl overflow-hidden shadow-2xl ring-1 ring-white/10 relative isolate transform-gpu">
                  <LazyCarouselContent activeIndex={current - 1} radius={2} className="h-full ml-0">
                    {/* SLIDE 1: HERO */}
                    <CarouselItem className="h-full pl-0">
                      <div className="h-full w-full bg-gradient-to-br from-blue-600 to-indigo-600 flex flex-col items-center justify-center text-white px-4 relative overflow-hidden">
                        <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff15_1px,transparent_1px),linear-gradient(to_bottom,#ffffff15_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)]" />

                        {[...Array(8)].map((_, i) => (
                          <motion.div
                            key={i}
                            className="absolute w-1.5 h-1.5 bg-blue-200 rounded-full blur-[1px]"
                            initial={{
                              x: Math.random() * 1000,
                              y: Math.random() * 600,
                              opacity: 0,
                            }}
                            animate={{
                              y: [null, Math.random() * -100],
                              opacity: [0, 0.6, 0],
                            }}
                            transition={{
                              duration: Math.random() * 4 + 3,
                              repeat: Infinity,
                              delay: Math.random() * 2,
                            }}
                            style={{
                              left: `${Math.random() * 100}%`,
                              top: `${Math.random() * 100}%`,
                            }}
                          />
                        ))}

                        <motion.div
                          animate={{
                            y: [0, -30, 0],
                            scale: [1, 1.1, 1],
                            opacity: [0.3, 0.5, 0.3],
                          }}
                          transition={{
                            duration: 8,
                            repeat: Infinity,
                            ease: "easeInOut",
                          }}
                          className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] bg-blue-400 rounded-full blur-[120px] opacity-30 mix-blend-overlay"
                        />
                        <motion.div
                          animate={{
                            y: [0, 40, 0],
                            scale: [1, 1.2, 1],
                            opacity: [0.3, 0.6, 0.3],
                          }}
                          transition={{
                            duration: 10,
                            repeat: Infinity,
                            ease: "easeInOut",
                            delay: 1,
                          }}
                          className="absolute bottom-[-10%] right-[-10%] w-[600px] h-[600px] bg-indigo-400 rounded-full blur-[140px] opacity-30 mix-blend-overlay"
                        />

                        <motion.div
                          initial={{ opacity: 0, y: 30 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.8, ease: "easeOut" }}
                          className="text-center max-w-5xl z-10 relative"
                        >
                          <div className="mb-8 flex justify-center">
                            <div className="w-24 h-24 bg-white/10 backdrop-blur-md rounded-3xl flex items-center justify-center shadow-lg border border-white/20 relative group overflow-hidden p-4">
                              <img
                                src="/assets/alogo.png"
                                alt="Asha Logo"
                                className="w-full h-full object-contain relative z-10 drop-shadow-[0_0_10px_rgba(255,255,255,0.5)]"
                              />
                              <div className="absolute inset-0 bg-white/20 rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-500 opacity-0 group-hover:opacity-100" />
                            </div>
                          </div>

                          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-8 tracking-tighter drop-shadow-sm bg-clip-text text-transparent bg-gradient-to-b from-white via-white to-blue-200">
                            Asha Health
                          </h1>

                          <div className="relative inline-block mb-12">
                            <p className="text-lg md:text-xl lg:text-2xl font-light text-blue-50 max-w-4xl mx-auto leading-relaxed drop-shadow-sm">
                              The First{" "}
                              <span className="font-semibold text-white">
                                AI-Native Operating System
                              </span>{" "}
                              for Dental
                            </p>
                            <motion.div
                              initial={{ scaleX: 0 }}
                              animate={{ scaleX: 1 }}
                              transition={{ delay: 0.8, duration: 0.8 }}
                              className="absolute -bottom-2 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-blue-200 to-transparent opacity-50"
                            />
                          </div>

                          <div className="flex justify-center gap-6">
                            <Button
                              onClick={() => api?.scrollNext()}
                              size="lg"
                              className="bg-white text-blue-600 hover:bg-blue-50 font-bold text-lg px-10 py-7 rounded-full shadow-[0_0_20px_rgba(255,255,255,0.3)] hover:shadow-[0_0_30px_rgba(255,255,255,0.5)] transition-all transform hover:scale-105"
                            >
                              Start Tour <ArrowRight className="ml-2 h-5 w-5" />
                            </Button>
                          </div>
                        </motion.div>
                      </div>
                    </CarouselItem>

                    {/* OVERVIEW SECTION TITLE */}
                    <CarouselItem className="h-full pl-0">
                      <div className="h-full w-full bg-slate-900 flex flex-col items-center justify-center text-white p-8">
                        <div className="text-center space-y-6 max-w-4xl">
                           <div className="inline-flex items-center justify-center w-20 h-20 rounded-3xl bg-blue-500/10 text-blue-500 mb-4 border border-blue-500/20">
                             <Sparkles className="w-10 h-10" />
                           </div>
                           <h1 className="text-5xl md:text-7xl font-bold tracking-tight">
                             <span className="text-blue-400">Overview</span>
                           </h1>
                           <p className="text-xl md:text-2xl text-slate-400 max-w-2xl mx-auto">
                             Understanding the current state of practice operations
                           </p>
                        </div>
                      </div>
                    </CarouselItem>

                    {/* WHY ASHA */}
                    <CarouselItem className="h-full pl-0">
                      <div className="h-full w-full flex flex-row">
                        <div className="w-1/2 bg-blue-600 text-white flex flex-col justify-center p-20 relative overflow-hidden">
                          <div className="absolute top-0 left-0 w-64 h-64 bg-blue-500 rounded-full blur-3xl opacity-20 -translate-x-1/2 -translate-y-1/2" />
                          <div className="relative z-10">
                            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-12 leading-tight">
                              Why do practices choose to work with Asha Health?
                            </h2>

                            <div className="space-y-10">
                              <motion.div
                                initial={{ opacity: 0, x: -20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ delay: 0.1 }}
                              >
                                <h3 className="text-xl lg:text-2xl font-semibold mb-3 flex items-start gap-4">
                                  <span className="flex-shrink-0 bg-white/20 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mt-1">
                                    1
                                  </span>
                                  <span>We're the only 1-stop shop for dental AI.</span>
                                </h3>
                                <p className="text-blue-100 leading-relaxed pl-12 text-lg opacity-90">
                                  Not just an AI receptionist. A full team of
                                  front office + back office AI agents. No need
                                  for 10 different vendors for isolated point
                                  solutions that don't connect.
                                </p>
                              </motion.div>

                              <motion.div
                                initial={{ opacity: 0, x: -20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ delay: 0.3 }}
                              >
                                <h3 className="text-xl lg:text-2xl font-semibold mb-3 flex items-start gap-4">
                                  <span className="flex-shrink-0 bg-white/20 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mt-1">
                                    2
                                  </span>
                                  <span>Strongest backing in dental AI.</span>
                                </h3>
                                <p className="text-blue-100 leading-relaxed pl-12 text-lg opacity-90">
                                  Most amount of institutional capital raised,
                                  backed by Y-Combinator & General Catalyst.
                                  Built by Google AI product leaders & health
                                  system CMOs.
                                </p>
                              </motion.div>
                            </div>
                          </div>
                        </div>

                        <div className="w-1/2 bg-slate-100 relative h-full">
                          <img
                            src="/assets/doctorimage1.jpg"
                            alt="Dental Professional"
                            className="w-full h-full object-cover object-center"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent flex items-end p-12">
                            <div className="text-white">
                              <p className="font-medium text-xl mb-2">
                                Trusted by top practices
                              </p>
                              <div className="flex gap-1">
                                {[1, 2, 3, 4, 5].map((i) => (
                                  <Star
                                    key={i}
                                    className="fill-yellow-400 text-yellow-400 w-6 h-6"
                                  />
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </CarouselItem>

                    {/* BACKING */}
                    <CarouselItem className="h-full pl-0">
                      <BackingSlide />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <DeRiskProcessSlide />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <ProblemResonanceSlide />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <AIOSEmphasisSlide onNavigate={(slug) => {
                        const idx = osSlides.findIndex(s => s.slug === slug);
                        if (idx !== -1) api?.scrollTo(idx);
                      }} />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <WhoWeTakeOnSlide />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <PartnershipSlide />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <AutomationInflectionPointSlide />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <AshaCortexSlide />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0"><OverviewTestimonialsSlide excludePractices={excludePractices} /></CarouselItem>

                    {/* THE ASHA TRANSFORMATION SECTION TITLE */}
                    <CarouselItem className="h-full pl-0">
                      <div className="h-full w-full bg-slate-900 flex flex-col items-center justify-center text-white p-8">
                        <div className="text-center space-y-6 max-w-4xl">
                           <div className="inline-flex items-center justify-center w-20 h-20 rounded-3xl bg-blue-500/10 text-blue-400 mb-4 border border-blue-500/20">
                             <TrendingUp className="w-10 h-10" />
                           </div>
                           <h1 className="text-5xl md:text-7xl font-bold tracking-tight">
                             The <span className="text-blue-400">ASHA Transformation</span>
                           </h1>
                           <p className="text-xl md:text-2xl text-slate-400 max-w-2xl mx-auto">
                             How Asha transforms the way practices operate
                           </p>
                        </div>
                      </div>
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <PerceivedOpportunitySlide />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <RealOpportunitySlide />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <AtomicAutomationSlide />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <ConsolidationSlide />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <ManualTasksSlide />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <HowCanWeHelpSlide />
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0">
                      <PlatformAndAIWorkforceSlide />
                    </CarouselItem>

                    {/* FRONT OFFICE AI TEAM */}
                    <CarouselItem className="h-full pl-0">
                      <PMSTeamIntro1Slide
                        onAgentClick={(slug) => {
                          if (slug) {
                            const slideIndex = osSlides.findIndex((s) => s.slug === slug);
                            if (slideIndex !== -1) {
                              api?.scrollTo(slideIndex);
                            }
                          }
                        }}
                      />
                    </CarouselItem>

                    {/* AMY */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Amy" role="AI Dental Receptionist" image="/assets/amy.png" subtitle="Answers calls 24/7, and books patients directly into Asha PMS." demoScenario={agentDemoScenarios.amy} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><AIReceptionistSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><IntelligentSchedulingSlide /></CarouselItem>

                    {/* LEENA */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Leena" role="Schedule Optimizer" image="/assets/leena.png" subtitle="The intelligent agent who proactively keeps your chairs full and production high." demoScenario={agentDemoScenarios.leena} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><LenaSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><LenaWorkflowSlide /></CarouselItem>

                    {/* STEPHANIE */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Stephanie" role="Hygiene Recall Specialist" image="/assets/stephanie.png" subtitle="Runs intelligent AI voice campaigns to reactivate patients and fill your hygiene schedule." demoScenario={agentDemoScenarios.stephanie} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><HygieneRecallSlide /></CarouselItem>

                    {/* KIM */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Kim" role="Case Acceptance Specialist" image="/assets/kim.png" subtitle="Turning unscheduled treatment plans into booked appointments and revenue." demoScenario={agentDemoScenarios.kim} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><KimCaseAcceptanceSlide /></CarouselItem>

                    {/* ELISE */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Elise" role="Patient Experience Coordinator" image="/assets/elise.png" subtitle="Ensuring every patient feels heard and turning happy visits into 5-star reviews." demoScenario={agentDemoScenarios.elise} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><ElisePatientExperienceSlide /></CarouselItem>

                    {/* MORGAN */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Morgan" role="Patient Intake Specialist" image="/assets/morgan.png" subtitle="Ensures patients complete intake forms and provide insurance info before they arrive." demoScenario={agentDemoScenarios.morgan} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><MorganPatientIntakeSlide /></CarouselItem>

                    {/* TRISHA */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Trisha" role="AI Practice Manager" image="/assets/trisha.png" subtitle="Monitors your entire AI workforce and assigns human follow-up only when necessary." demoScenario={agentDemoScenarios.trisha} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><PracticeManagerSlide /></CarouselItem>

                    {/* COMMUNICATION SUITE */}
                    <CarouselItem className="h-full pl-0"><CommunicationTitleSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><VoIPSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><NextGenFormsSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><CommunicationSuiteSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><EFAXSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><SMSCampaignsSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><EmailCampaignsSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><PhysicalPhonesSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><TextToPaySlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><CardReadersSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><TeamChatSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><OnlineSchedulingSlide /></CarouselItem>

                    {/* REVENUE CYCLE AI TEAM */}
                    <CarouselItem className="h-full pl-0">
                      <PMSTeamIntro2Slide
                        onAgentClick={(slug) => {
                          if (slug) {
                            const slideIndex = osSlides.findIndex((s) => s.slug === slug);
                            if (slideIndex !== -1) {
                              api?.scrollTo(slideIndex);
                            }
                          }
                        }}
                      />
                    </CarouselItem>

                    {/* AMANDA */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Amanda" role="Insurance Verification Specialist" image="/assets/amanda.png" subtitle="The only AI that performs dual-source insurance verification to get you more accurate and comprehensive benefits breakdowns." demoScenario={agentDemoScenarios.amanda} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><InsuranceVerificationSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><ComprehensiveBreakdownsSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0">
                      <InsuranceCopilotSlide isActive={current === (osSlides.findIndex(s => s.slug === "amanda-copilot") + 1)} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><BenefitFormsSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><InsuranceCallingSlide /></CarouselItem>

                    {/* ARIEL */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Ariel" role="AI Claims Expert" image="/assets/ariel.png" subtitle="Submitting clean claims with perfect clinical documentation instantly." theme="dark" demoScenario={agentDemoScenarios.ariel} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><ArielSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><AlainaSlide /></CarouselItem>

                    {/* ALISHA */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Alisha" role="EOB Posting Specialist" image="/assets/alisha.png" subtitle="Posts explanation of benefits and insurance payments automatically." theme="dark" demoScenario={agentDemoScenarios.alisha} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><EOBProcessingSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><PaymentReconciliationSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><EOBStreamliningSlide /></CarouselItem>

                    {/* KIANNA */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide name="Kianna" role="Patient Billing" image="/assets/kianna.png" subtitle="Uses intelligent voice AI campaigns to help patients pay their balances." theme="dark" demoScenario={agentDemoScenarios.kianna} />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><PatientBillingSlide /></CarouselItem>

                    {/* SARAH - DENIAL MANAGEMENT */}
                    <CarouselItem className="h-full pl-0">
                      <AgentTitleSlide
                        name="Sarah"
                        role="Denial Management Specialist"
                        image="/assets/sarah.png"
                        subtitle="Analyzes denied claims with multi-step AI reasoning and generates appeals, corrected claims, or write-offs with one tap."
                        theme="dark"
                        demoScenario={agentDemoScenarios.sarah}
                      />
                    </CarouselItem>
                    <CarouselItem className="h-full pl-0"><DenialManagementSlide /></CarouselItem>

                    {/* HUMAN BILLER */}

                    {/* REVENUE ANALYTICS SECTION TITLE */}
                    <CarouselItem className="h-full pl-0">
                      <div className="h-full w-full bg-slate-900 flex flex-col items-center justify-center text-white p-8">
                        <div className="text-center space-y-6 max-w-4xl">
                           <div className="inline-flex items-center justify-center w-20 h-20 rounded-3xl bg-blue-500/10 text-blue-400 mb-4 border border-blue-500/20">
                             <TrendingUp className="w-10 h-10" />
                           </div>
                           <h1 className="text-5xl md:text-7xl font-bold tracking-tight">
                             Revenue <span className="text-blue-400">Analytics Suite</span>
                           </h1>
                           <p className="text-xl md:text-2xl text-slate-400 max-w-2xl mx-auto">
                             See exactly how your practice is performing — in real time.
                           </p>
                        </div>
                      </div>
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0"><PMSRevenueAnalyticsSlide /></CarouselItem>

                    {/* PMS FEATURES SECTION TITLE */}
                    <CarouselItem className="h-full pl-0">
                      <div className="h-full w-full bg-slate-900 flex flex-col items-center justify-center text-white p-8">
                        <div className="text-center space-y-6 max-w-4xl">
                           <div className="inline-flex items-center justify-center w-20 h-20 rounded-3xl bg-indigo-500/10 text-indigo-500 mb-4 border border-indigo-500/20">
                             <Sparkles className="w-10 h-10" />
                           </div>
                           <h1 className="text-5xl md:text-7xl font-bold tracking-tight">
                             Core <span className="text-indigo-400">PMS Features</span>
                           </h1>
                           <p className="text-xl md:text-2xl text-slate-400 max-w-2xl mx-auto">
                             Everything you need to manage your dental practice
                           </p>
                        </div>
                      </div>
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0"><PMSAshaCopilotSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><PMSSchedulingSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><PMSChartingSlideAnimated /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><VoicePerioSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><AIDictationSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><PMSClinicalNotesSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><PMSFileManagementSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><PMSImagingSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><PMSAITreatmentPlannerSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><PMSAIScribeSlide /></CarouselItem>

                    {/* ============================================ */}
                    {/* ENGAGEMENT & PRICING — single consolidated section */}
                    {/* ============================================ */}

                    {/* TWO ENGAGEMENT MODELS — intro */}
                    <CarouselItem className="h-full pl-0"><EngagementOptionsSlide /></CarouselItem>

                    {/* WHAT YOU GET — 10 Softwares + 20 AI Products emphasis */}
                    <CarouselItem className="h-full pl-0">
                      <AIOSEmphasisSlide onNavigate={(slug) => {
                        const idx = osSlides.findIndex(s => s.slug === slug);
                        if (idx !== -1) api?.scrollTo(idx);
                      }} />
                    </CarouselItem>

                    {/* PMS INTEGRATIONS & MIGRATIONS — broader partner list */}
                    <CarouselItem className="h-full pl-0"><MigrationPartnersSlide /></CarouselItem>

                    {/* SEAMLESS DATA MIGRATION */}
                    <CarouselItem className="h-full pl-0"><DataMigrationSlide /></CarouselItem>

                    {/* PRICING — moved to /ai-os-pricing deck */}

                    {/* ONBOARDING & STRATEGY ADVISORY */}
                    <CarouselItem className="h-full pl-0"><WhiteGloveOnboardingSlide /></CarouselItem>

                    {/* 4-WEEK GO-LIVE */}
                    <CarouselItem className="h-full pl-0"><GoLiveTimelineSlide /></CarouselItem>

                    {/* ============================================ */}
                    {/* ROI IMPACT */}
                    {/* ============================================ */}
                    <CarouselItem className="h-full pl-0">
                      <div className="h-full w-full bg-slate-900 flex flex-col items-center justify-center text-white p-8">
                        <div className="text-center space-y-6 max-w-4xl">
                           <div className="inline-flex items-center justify-center w-20 h-20 rounded-3xl bg-amber-500/10 text-amber-400 mb-4 border border-amber-500/20">
                             <TrendingUp className="w-10 h-10" />
                           </div>
                           <h1 className="text-5xl md:text-7xl font-bold tracking-tight">
                             ROI <span className="text-amber-400">Impact</span>
                           </h1>
                           <p className="text-xl md:text-2xl text-slate-400 max-w-2xl mx-auto">
                             See exactly what Asha pays back — month over month.
                           </p>
                        </div>
                      </div>
                    </CarouselItem>

                    {/* ROI CALCULATOR */}
                    <CarouselItem className="h-full pl-0"><ROICalculatorSlide /></CarouselItem>

                    <CarouselItem className="h-full pl-0"><AshaBasicallyFreeSlide /></CarouselItem>

                    {/* RCM PRICING COMPARISON — removed */}

                    {/* AI INNOVATION FELLOWS SECTION TITLE */}
                    <CarouselItem className="h-full pl-0">
                      <div className="h-full w-full flex flex-row">
                        <div className="w-1/2 bg-slate-900 text-white flex flex-col justify-center p-20 relative overflow-hidden">
                          <div className="absolute top-0 left-0 w-64 h-64 bg-blue-500 rounded-full blur-3xl opacity-20 -translate-x-1/2 -translate-y-1/2" />
                          <div className="relative z-10">
                            <div className="inline-flex items-center justify-center w-20 h-20 rounded-3xl bg-blue-500/10 text-blue-400 mb-6 border border-blue-500/20">
                              <Star className="w-10 h-10" />
                            </div>
                            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight mb-6">
                              AI Innovation <span className="text-blue-400">Fellows</span>
                            </h1>
                            <p className="text-xl md:text-2xl text-slate-400 max-w-2xl leading-relaxed">
                              For ambitious physicians who want to establish themselves as thought leaders for AI in dentistry.
                            </p>
                          </div>
                        </div>
                        <div className="w-1/2 bg-slate-100 relative h-full">
                          <img
                            src="/assets/dentist.jpg"
                            alt="Innovation Fellows"
                            className="w-full h-full object-cover object-center"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent flex items-end p-12">
                            <div className="text-white">
                              <p className="font-medium text-xl mb-2 flex items-center gap-2">
                                <Sparkles className="w-5 h-5 text-blue-400" />
                                Shaping the future of clinical AI
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0"><FellowsIntroSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><FellowsPartnerPerksSlide /></CarouselItem>

                    {/* FAQ SECTION TITLE */}
                    <CarouselItem className="h-full pl-0">
                      <div className="h-full w-full bg-slate-900 flex flex-col items-center justify-center text-white p-8">
                        <div className="text-center space-y-6 max-w-4xl">
                           <div className="inline-flex items-center justify-center w-20 h-20 rounded-3xl bg-blue-500/10 text-blue-500 mb-4 border border-blue-500/20">
                             <Sparkles className="w-10 h-10" />
                           </div>
                           <h1 className="text-5xl md:text-7xl font-bold tracking-tight">
                             Common <span className="text-blue-400">Questions</span>
                           </h1>
                           <p className="text-xl md:text-2xl text-slate-400 max-w-2xl mx-auto">
                             Everything you need to know about partnering with Asha.
                           </p>
                        </div>
                      </div>
                    </CarouselItem>

                    <CarouselItem className="h-full pl-0"><FAQSlide /></CarouselItem>
                    <CarouselItem className="h-full pl-0"><AICreditFAQSlide /></CarouselItem>

                  </LazyCarouselContent>
                </div>
              </Carousel>
            </div>
          </div>

          <Button
            variant="outline"
            size="icon"
            className="absolute -left-6 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/40 border-0 text-slate-800 hover:text-slate-900 h-12 w-12 rounded-full backdrop-blur-sm shadow-sm z-50 disabled:opacity-50"
            onClick={() => api?.scrollPrev()}
            disabled={!api || current <= 1}
          >
            <ArrowLeft className="h-6 w-6" />
            <span className="sr-only">Previous slide</span>
          </Button>

          <Button
            variant="outline"
            size="icon"
            className="absolute -right-6 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/40 border-0 text-slate-800 hover:text-slate-900 h-12 w-12 rounded-full backdrop-blur-sm shadow-sm z-50 disabled:opacity-50"
            onClick={() => api?.scrollNext()}
            disabled={!api || current >= count}
          >
            <ArrowRight className="h-6 w-6" />
            <span className="sr-only">Next slide</span>
          </Button>
        </div>
      </div>
      {/* Mobile Alert */}
      <div className="fixed bottom-0 left-0 right-0 bg-blue-600/90 backdrop-blur-md text-white text-center py-3 px-4 text-xs font-semibold xl:hidden z-50 border-t border-blue-400/30 shadow-lg">
        This slideshow is designed best to be viewed on a laptop.
      </div>
    </div>
  );
};

export default AIOSSlideshowPage;
